"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCollisionStatus = exports.isInManageableApprovalStatus = exports.isInProgressApprovalStatus = exports.isResumeApprovalStatus = exports.isActiveApprovalStatus = exports.isNotStartApprovalStatus = exports.isStartApprovalStatus = exports.isEndApprovalStatus = void 0;
var types_1 = require("../common/types");
exports.isEndApprovalStatus = function (status) {
    return status === types_1.ApprovalSheetStatus.REJECTED_FLOW || status === types_1.ApprovalSheetStatus.COMPLETED_FLOW;
};
exports.isStartApprovalStatus = function (status) {
    return status === types_1.ApprovalSheetStatus.CREATED_FLOW;
};
exports.isNotStartApprovalStatus = function (status) {
    return status !== types_1.ApprovalSheetStatus.CREATED_FLOW;
};
exports.isActiveApprovalStatus = function (status) {
    return status === types_1.ApprovalSheetStatus.ACTIVE_FLOW;
};
exports.isResumeApprovalStatus = function (status) {
    return (status === types_1.ApprovalSheetStatus.STOPPED_FLOW ||
        status === types_1.ApprovalSheetStatus.CHECKING_COLLISION_FLOW ||
        status === types_1.ApprovalSheetStatus.VERIFICATION_FLOW);
};
exports.isInProgressApprovalStatus = function (status) {
    return exports.isNotStartApprovalStatus(status) && !exports.isEndApprovalStatus(status);
};
exports.isInManageableApprovalStatus = function (status) {
    return exports.isStartApprovalStatus(status) || exports.isResumeApprovalStatus(status);
};
exports.isCollisionStatus = function (status) {
    return status === types_1.ApprovalSheetStatus.VERIFICATION_FLOW;
};
